import React from 'react';
import { Popup } from '../Popup';
import ChangeOfferContent from '../ChangeOfferContent';

export default props => {
    return (
        <>
            {props.isChangeOfferTypePopupOpen && <Popup
                isExtraLarge={true}
                hasBottomButton={false}
                close={props.resetChangeOfferPopup}
            >
                <ChangeOfferContent {...props.offer} />
            </Popup>
            }
        </>
    );
}